import { useState } from 'react';
import { Offcanvas } from 'react-bootstrap';

function SignatureOffCanvas({ show, handleClose, handleSave, title, initialValue }) {
  const [offCanvasState, setOffCanvasState] = useState(initialValue);

  const handleReset = () => {
    handleSave({ file: null });
  };
  return (
    <Offcanvas show={show} onHide={handleClose} placement={'end'}>
      <Offcanvas.Header closeButton className="border-bottom">
        <Offcanvas.Title>{title}</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <div className="mb-3">
          <label className="d-block" style={{ fontSize: '24px' }} htmlFor="name">
            Signatory Name
          </label>
          <input
            id="name"
            placeholder="Type here..."
            defaultValue={initialValue?.name}
            style={{
              width: '100%',
              height: '100%',
              padding: '10px'
            }}
            onChange={(e) =>
              setOffCanvasState({
                ...offCanvasState,
                name: e.target.value
              })
            }
          />
        </div>

        <div className="mb-3">
          <label className="d-block" style={{ fontSize: '24px' }} htmlFor="nameFontSize">
            Font size:
          </label>
          <input
            id="nameFontSize"
            style={{
              padding: '5px'
            }}
            type="number"
            defaultValue={initialValue?.nameFontSize || 16}
            onChange={(e) =>
              setOffCanvasState({
                ...offCanvasState,
                nameFontSize: e.target.value
              })
            }
          />
        </div>

        <div className="mb-3">
          <label className="d-block" style={{ fontSize: '24px' }} htmlFor="nameColor">
            Color:
          </label>
          <input
            id="nameColor"
            type="color"
            defaultValue={initialValue?.nameColor}
            onChange={(e) =>
              setOffCanvasState({
                ...offCanvasState,
                nameColor: e.target.value
              })
            }
          />
        </div>

        <hr />

        <div className="mb-3">
          <label className="d-block" style={{ fontSize: '24px' }} htmlFor="post">
            Signatory Post
          </label>
          <input
            id="post"
            placeholder="Type here..."
            defaultValue={initialValue?.post}
            style={{
              width: '100%',
              height: '100%',
              padding: '10px'
            }}
            onChange={(e) =>
              setOffCanvasState({
                ...offCanvasState,
                post: e.target.value
              })
            }
          />
        </div>

        <div className="mb-3">
          <label className="d-block" style={{ fontSize: '24px' }} htmlFor="postFontSize">
            Font size:
          </label>
          <input
            id="postFontSize"
            type="number"
            defaultValue={initialValue?.postFontSize || 16}
            onChange={(e) =>
              setOffCanvasState({
                ...offCanvasState,
                postFontSize: e.target.value
              })
            }
            style={{
              padding: '5px'
            }}
          />
        </div>

        <div className="mb-3">
          <label className="d-block" style={{ fontSize: '24px' }} htmlFor="postColor">
            Color:
          </label>
          <input
            id="postColor"
            type="color"
            defaultValue={initialValue?.postColor}
            onChange={(e) =>
              setOffCanvasState({
                ...offCanvasState,
                postColor: e.target.value
              })
            }
          />
        </div>

        <button
          className="btn btn-primary w-100 mt-3"
          onClick={() => {
            if (handleSave) handleSave(offCanvasState);
          }}>
          Save
        </button>

        <div className="border-top mt-3 pt-4">
          <button className="btn btn-outline-danger" onClick={handleReset}>
            Reset
          </button>
        </div>
      </Offcanvas.Body>
    </Offcanvas>
  );
}

export default SignatureOffCanvas;
